import React from 'react';

interface LoadingProps {
  message?: string;
}

const Loading: React.FC<LoadingProps> = ({ message = 'Loading...' }) => {
  return (
    <div className="loading-container">
      <img src="/loading.svg" alt="" className="loading-spinner" />
      <p className="loading-message">{message}</p>
    </div>
  );
};

export default Loading;
